/// <reference path="./index.d.ts" />
import React from 'react';
import { getProductCoupons, applyCoupon, Xman } from './service';
import { Coupon } from './coupon';
import './index.scss';

interface Iprops {
  aliMemberId: string;
  uniqueToken: string;
  productId: string;
  language: string;
  i18n: object;
}

interface Istate {
  loaded: boolean;
  activityList: PcCoupon.IActivity[];
}

export default class CouponRender extends React.PureComponent<Iprops, Istate> {
  state = {
    loaded: false,
    activityList: [],
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    const { aliMemberId, uniqueToken, productId, language } = this.props;

    getProductCoupons({
      publisherId: aliMemberId,
      participateId: productId,
      _csrf_token: uniqueToken,
      rangeType: 'product',
      applyPlace: 'detail',
      languageType: language,
    }).then((res: PcCoupon.IQueryResult) => {
      if (res.code === 200) {
        // 后端给出的所有的券都是能用的，所以删掉了所有的生效时间和过期时间
        const activityList = res.data.couponSpreadList;
        if (activityList && activityList.length > 0) {
          this.setState({
            loaded: true,
            activityList,
          });
        }
      }
    });
  }

  render() {
    const { loaded, activityList } = this.state;
    if (!loaded) return null;

    const { productId, language, i18n } = this.props;

    return (
      <Coupon
        productId={productId}
        services={{
          Xman,
          CouponActivityService: { getProductCoupons },
          CouponCardService: { applyCoupon },
        }}
        i18n={i18n}
        activities={activityList}
        languageType={language}
      />
    );
  }
}
